import React from "react";
import PropTypes from "prop-types";
import { useSetSliderRef } from "context/Slider";

const SliderResizableComponent = ({ className, children }) => {
  const setSliderRef = useSetSliderRef();

  return (
    <div className={className} ref={setSliderRef}>
      {children}
    </div>
  );
};

SliderResizableComponent.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default SliderResizableComponent;
